import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Button, CircularProgress } from "@material-ui/core"
import { Spacer } from "../../../components/spacer"
import { useNotify } from "react-admin"
import dataProvider from "../../../providers/data-provider"
import { useState } from "react"
import { Cancel, Save } from "@material-ui/icons"

export const ActivityFinishDialog = ({ open, onClose, activity, process, onFinished, ...props }) => {

    const notify = useNotify()

    const [loading, setLoading] = useState(false)

    const handleSubmit = async () => {
        setLoading(true)
        await dataProvider.post('activities', `${activity?.id}/toggleFinish`, { id: activity.id })
            .then(response => {
                if (response.status === 500) {
                    notify('Erro', 'error')
                } else {
                    notify('Movimentação atualizada com sucesso', 'success')
                    onFinished()
                }
            })
            .catch((error) => {
                notify(error, 'error')
            }).finally(() => {
                setLoading(false)
                onClose();
            })
    }

    return (
        <Dialog open={open} onClose={onClose}>
            <DialogTitle>{activity?.finished ? `Reativar movimentação` : `Encerrar movimentação`}</DialogTitle>
            <DialogContent>
                <DialogContentText>{`Deseja ${activity?.finished ? `reativar` : `encerrar`} a movimentação ${activity?.type.name} do atendimento ${process?.alias}?`}</DialogContentText>
                <DialogContentText>{`Você pode desfazer esta ação a qualquer momento filtrando esta movimentação no dashboard e clicando no botão Encerrar/Reativar.`}</DialogContentText>
                <DialogActions>
                    <Button onClick={onClose} variant="contained" startIcon={<Cancel />}>Cancelar</Button>
                    <Spacer />
                    <Button variant="contained" color="primary" onClick={handleSubmit} startIcon={loading ? <CircularProgress size={16} /> : <Save />}>{activity?.finished ? `Reativar` : `Encerrar`}</Button>
                </DialogActions>
            </DialogContent>
        </Dialog>
    )
}